<template>
  <span v-if="brand" class="brand" :title="brand">
    {{ brand }}
  </span>
</template>

<script>
export default {
  props: {
    brand: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.brand {
  @extend %ellipsis;

  color: var(--color-text-secondary);
  // ensure the brand always yields space
  // to the neighbour flex elements (e.g. the result source)
  flex-basis: 0;
  flex-grow: 1;
}
</style>
